import axios, { AxiosResponse } from "axios";
import { IViaCepResponse } from "../Interfaces/Responses/ViaCep/IViaCepResponse";

export interface IViaCepAPI {
  getAdress(cep: string): Promise<AxiosResponse<IViaCepResponse>>;
  getLatLng(cep: string): Promise<AxiosResponse<any>>;
}

class ViaCepAPI implements IViaCepAPI {
  async getAdress(cep: string): Promise<AxiosResponse<IViaCepResponse>> {
    const url = `https://viacep.com.br/ws/${cep}/json/`;
    const response = axios.get<IViaCepResponse>(url);
    return response;
  }
  async getLatLng(cep: string): Promise<AxiosResponse<any>> {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${cep}&language=pt-BR&key=AIzaSyC4i4niapScJOv2uotIxwomJlMn1QUTyic`;
    const response = axios.get<any>(url);
    return response;
  }
}

const instance = new ViaCepAPI();

export default instance;
